<div class="emds table-responsive-sm" [ngClass]="{'table-overflow-auto' : !setStickyHeaders}">
  <table id="{{Id}}" class="table emds-table table-striped table-borderless mt-2" [ngClass]="{'table-sticky-header' : setStickyHeaders}"  >
    <thead>
      <tr>
        <th *ngFor="let columnInfo of columnInfoListToShow">
          <!-- Translations with configurable headings will be an issue - looking into calling translate from ts code -->
          {{columnInfo.HeaderDisplayName}}
        </th>
      </tr>
    </thead>

    <tbody *ngFor="let group of mainDataItmLst">
      <tr *ngIf="group.GroupName?.length > 0">
        <td [attr.colspan]="columnInfoListToShow.length" class="table-group-header" >{{group.GroupName}}</td>
      </tr>
      <ng-container *ngFor="let dataItem of group.GroupLst">
        <tr *ngIf="!dataItem.Deleted" [ngClass]="dataItem.CssClass ? dataItem.CssClass : ''">
          <td *ngFor="let columnInfo of columnInfoListToShow" 
            [ngStyle]="columnInfo.Format?.NgStyleProperties(dataItem)" 
            
            [ngClass]="columnInfo.Format ? columnInfo.Format.AdditionalElementClasses : ''">
              <ng-container [ngSwitch]="columnInfo.FieldTypeObject.FieldType" >
                <ng-container *ngSwitchCase="ColumnFieldTypes.String">
                  <ap-column-string [baseId]="Id" [columnName]="columnInfo.ColumnName" [columnInfoDto]="columnInfo.FieldTypeObject" [dataItem]="dataItem"></ap-column-string>
                </ng-container>
                <ng-container *ngSwitchCase="ColumnFieldTypes.Number">
                  <ap-column-number [baseId]="Id" [columnName]="columnInfo.ColumnName" [columnInfoDto]="columnInfo.FieldTypeObject" [dataItem]="dataItem"></ap-column-number>
                </ng-container>
                <ng-container *ngSwitchCase="ColumnFieldTypes.Date">
                  <ap-column-date [baseId]="Id" [columnName]="columnInfo.ColumnName" [columnInfoDto]="columnInfo.FieldTypeObject" [dataItem]="dataItem"></ap-column-date>
                </ng-container>
                <ng-container *ngSwitchCase="ColumnFieldTypes.HyperLink">
                  <ap-column-hyperlink [baseId]="Id" [columnName]="columnInfo.ColumnName" [columnInfoDto]="columnInfo.FieldTypeObject" [dataItem]="dataItem"></ap-column-hyperlink>
                </ng-container>
                <ng-container *ngSwitchCase="ColumnFieldTypes.Dropdown">
                  <ap-column-dropdown [baseId]="Id" [columnName]="columnInfo.ColumnName" [columnInfoDto]="columnInfo.FieldTypeObject" [dataItem]="dataItem"></ap-column-dropdown>
                </ng-container>
                <ng-container *ngSwitchCase="ColumnFieldTypes.Html">
                  <ap-column-html [baseId]="Id" [columnName]="columnInfo.ColumnName" [columnInfoDto]="columnInfo.FieldTypeObject" [dataItem]="dataItem"></ap-column-html>
                </ng-container>
                <ng-container *ngSwitchCase="ColumnFieldTypes.TimeFrame">
                  <ap-column-timeframe [baseId]="Id" [columnName]="columnInfo.ColumnName" [columnInfoDto]="columnInfo.FieldTypeObject" [dataItem]="dataItem"></ap-column-timeframe>
                </ng-container>
                <ng-container *ngSwitchCase="ColumnFieldTypes.Checkbox">
                  <ap-column-checkbox [baseId]="Id" [columnName]="columnInfo.ColumnName" [columnInfoDto]="columnInfo.FieldTypeObject" [dataItem]="dataItem"></ap-column-checkbox>
                </ng-container>
                <ng-container *ngSwitchCase="ColumnFieldTypes.ActionIcons">
                  <ap-column-action-icons [baseId]="Id" [columnName]="columnInfo.ColumnName" [columnInfoDto]="columnInfo.FieldTypeObject" [dataItem]="dataItem"></ap-column-action-icons>
                </ng-container>
                <ng-container *ngSwitchCase="ColumnFieldTypes.FindControl">
                  <ap-column-findcontrol [baseId]="Id" [columnName]="columnInfo.ColumnName" [columnInfoDto]="columnInfo.FieldTypeObject" [dataItem]="dataItem"></ap-column-findcontrol>
                </ng-container>
                
                <div class="alert-warning" *ngSwitchDefault translate>
                  Unknown table column type
                </div>
              </ng-container>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>
